function n(){return"2.14.0"}export{n as getVersion};
